export const routesKullanicilar = [
  {
    path: "/kullanicilar",
    name: "kullanicilar",
    component: () => import("@/views/kullanicilar/index.vue"),
    meta: {
      public: false,
      title: "kullanicilar.Kullanıcılar",
      yetki: { k: [1000002] },
    },
  },
  {
    path: "/kullanicilar/:userId",
    name: "kullanicilar_profil",
    component: () => import("@/views/kullanicilar/profil/index.vue"),
    meta: {
      public: false,
      title: "kullanicilar.Kullanıcı Profil",
      yetki: { k: [1000002] },
    },
  },
  {
    path: "/groupyetki",
    name: "groupyetki",
    component: () => import("@/views/kullanicilar/groupyetki/index.vue"),
    meta: {
      public: false,
      yetki: { k: [1000102] },
      title: "kullanicilar.Group Yetki",
    },
  },
  {
    path: "/yetki",
    name: "yetki",
    component: () => import("@/views/kullanicilar/yetki/index.vue"),
    meta: {
      public: false,
      yetki: { k: [1000102] },
      title: "kullanicilar.Yetki",
    },
  },
  {
    path: "/kullanici_yetki_liste",
    name: "kullanici_yetki_liste",
    component: () => import("@/views/kullanicilar/kullanici_yetki_liste/index.vue"),
    meta: {
      public: false,
      yetki: { k: [1000102, 1000002] },
      title: "kullanicilar.Kullanıcı Yetki Listesi",
    },
  },
]
